import React, {useMemo} from "react"
import { Layout } from "./Layout";
import {useSiren} from "./SirenContext";
import {ContactGroupCreate} from "./subpages/ContactGroupCreate";
import { ContactGroupList } from "./subpages/ContactGroupList";

export function Groups() {
    const {subMenuCurrent} = useSiren()

    const page = useMemo(() => {
        switch (subMenuCurrent) {
            case "create": return <ContactGroupCreate/>
            case "active": return <ContactGroupList/>
            case "archived": return <ContactGroupList archived/>
        }

        return null
    },[subMenuCurrent])


    return (
        <Layout menuCurrent={"groups"} >
            {page}
        </Layout>
    )



}